import moment from "moment";
export function setLoading(state, loading){
    state.loading = loading
}

export function setReportData(state,data){
    state.report_data = data
}
export function setDocumentProductReportData(state,data){
    state.document_products = data
}

export function subtractMonthsToDate(date, quantity_months) {

    const date_clone = new Date(date);
    // Obtener el mes y año actuales
    const current_month = date_clone.getMonth();
    const current_year = date_clone.getFullYear();

    // Calcular el nuevo mes y año
    let new_month = current_month - quantity_months;
    let new_year = current_year;

    // Manejar el cambio de año si el nuevo mes es menor a 0
    while (new_month < 0) {
        new_month += 12;
        new_year--;
    }

    // Establecer la nueva fecha con los meses restados
    date_clone.setMonth(new_month);
    date_clone.setFullYear(new_year);

    return date_clone;
}

export function setDateRangeParam(state) {
    const date_current = new Date(); // Fecha actual

    // Restar un mes a la fecha actual para obtener el mes anterior
    const date_month_previous = subtractMonthsToDate(date_current, 1);

    // Obtener el primer día del mes anterior
    const first_day_month_previous = new Date(date_month_previous.getFullYear(), date_month_previous.getMonth(), 1);

    // Obtener el último día del mes anterior
    //const ultimoDiaMesAnterior = new Date(date_month_previous.getFullYear(), date_month_previous.getMonth() + 1, 0);
    state.params.date = [
        moment(first_day_month_previous).format('YYYY-MM-DD'),
        moment(date_current).format('YYYY-MM-DD'),
    ];
}



// WEBPACK FOOTER //
// ./src/modules/report-document-pending-dispatch-order/mutations.js